export default __webpack_public_path__ + "static/media/GeneralManager.60ccfe45.png";